// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3lhFk","content":"LoadingAlert_content__1DVnV"};